import type { NoyauTextField } from '@/lib/noyau-texts-draft';
import { NOYAU_TEXT_FIELDS, NOYAU_TEXT_TOTAL } from '@/lib/noyau-texts-draft';

/**
 * The words of Réglages > Noyaux (noyau.md §6.3, issue #148), pure and in one
 * place, like every `*-labels.ts` of this front end.
 */

/** The three fields of a card, as the maquette names them. */
export const NOYAU_TEXT_FIELD_LABEL: Readonly<Record<NoyauTextField, string>> = {
  firstText: 'Premier texte',
  secondText: 'Second texte',
  portrait: 'Portrait',
};

/** « 2 sur 3 » - the counter of one card, green once all three are written. */
export function cardCountLabel(filled: number): string {
  return `${filled} sur ${NOYAU_TEXT_FIELDS.length}`;
}

/** « 7 sur 18 remplis » - the counter of the whole object (§6.3). */
export function totalCountLabel(filled: number): string {
  return `${filled} sur ${NOYAU_TEXT_TOTAL} remplis`;
}

/**
 * The sentence beside the global counter: why eighteen, and before what.
 *
 * Two readings of the same rule (N7). Before the v1 it is the condition of the
 * first save; after it, a version is always playable, so a text emptied in the
 * draft is what keeps the next one from being saved - and the save hint of the
 * layer, which only knows « rien n'a changé », would not say so.
 */
export function totalCountSentence(empty: boolean): string {
  return empty
    ? 'Douze versions de texte et six portraits : les dix-huit sont requis avant le premier enregistrement.'
    : 'Une version est toujours jouable : les dix-huit textes sont requis pour enregistrer la suivante.';
}
